import { lazy } from 'react';

export const MenuTreeList = lazy(() => import('./menutree-list'));


